import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-footer',
  template: `<div class="layout-footer">
    Programa de Referidores por
    <a
      href="https://www.inversiones.io"
      target="_blank"
      rel="noopener noreferrer"
      class="text-primary font-bold hover:underline"
      >Inversiones.io</a
    >
  </div>`,
})
export class AppFooter {}
